module.exports = __webpack_public_path__ + "img/mall04.43f74041.png";